import React, { FC } from 'react';
import { BrowserRouter as Router, BrowserRouter, Route, Switch } from 'react-router-dom';
import { AppNodeMode, MiniApplicationManifest } from 'core/helpers/dna';
import { LoginView } from './views/loginView';
import { SilentView } from './views/silentView';
import { LogoutView } from './views/logoutView';
import { AccessView } from './views/accessView';
import Stats from 'shared/pages/Stats/Stats';

const manifest: MiniApplicationManifest = {
    // Название мини-приложения - и document.title
    title: 'Burgundy Authorization',

    // объект редукторов (redux)
    reducer: {},

    // авторизация
    auth: {
        productionClientId: '',
        developClientId: '',
    },
    clear: true,
};

/**
 * Приложение. Это точка входа. Все начинается отсюда.
 * Провайдеры, оформление страницы - да все, что угодно!
 *
 * Любое свершение начинается с точки входа - удачного кодинга :)
 *
 * Переменная `mode` может принимать 3 значения: 'develop', 'staging' и 'production'
 */
const App: FC<{ mode: AppNodeMode }> = () => (
  <BrowserRouter>
    <Routes />
  </BrowserRouter>
);

/**
 * Компонент роутера - обязательная часть ядра Geograffee
 *
 * Отсюда маршрутизация по мини-приложению
 */
const Routes: FC = () => (
  <Router>
      <Switch>
          <Route exact path={'/login/callback'} component={LoginView} />
          <Route exact path={'/silent/callback'} component={SilentView} />
          <Route exact path={'/logout/callback'} component={LogoutView} />
          <Route exact path={'/access'} component={AccessView} />
          <Route exact path={'/stats'} component={Stats} />
      </Switch>
  </Router>
);

const app = { App, manifest };

// Это обязательная часть. Она очень важна!
export default app;
import React, { FC } from 'react';
import { BrowserRouter as Router, BrowserRouter, Route, Switch } from 'react-router-dom';
import { AppNodeMode, MiniApplicationManifest } from 'core/helpers/dna';
import { LoginView } from './views/loginView';
import { SilentView } from './views/silentView';
import { LogoutView } from './views/logoutView';
import { AccessView } from './views/accessView';
import Stats from 'shared/pages/Stats/Stats';

const manifest: MiniApplicationManifest = {
    // Название мини-приложения - и document.title
    title: 'Burgundy Authorization',

    // объект редукторов (redux)
    reducer: {},

    // авторизация
    auth: {
        productionClientId: '',
        developClientId: '',
    },
    clear: true,
};

/**
 * Приложение. Это точка входа. Все начинается отсюда.
 * Провайдеры, оформление страницы - да все, что угодно!
 *
 * Любое свершение начинается с точки входа - удачного кодинга :)
 *
 * Переменная `mode` может принимать 3 значения: 'develop', 'staging' и 'production'
 */
const App: FC<{ mode: AppNodeMode }> = () => (
  <BrowserRouter>
    <Routes />
  </BrowserRouter>
);

/**
 * Компонент роутера - обязательная часть ядра Geograffee
 *
 * Отсюда маршрутизация по мини-приложению
 */
const Routes: FC = () => (
  <Router>
      <Switch>
          <Route exact path={'/login/callback'} component={LoginView} />
          <Route exact path={'/silent/callback'} component={SilentView} />
          <Route exact path={'/logout/callback'} component={LogoutView} />
          <Route exact path={'/access'} component={AccessView} />
          <Route exact path={'/stats'} component={Stats} />
      </Switch>
  </Router>
);

const app = { App, manifest };

// Это обязательная часть. Она очень важна!
export default app;
